import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
export type StyleProps = {};
export const useStyles = makeStyles<Theme, StyleProps>(() =>
  createStyles({
    root: () => ({
      position: 'relative',
      padding: '16px 16px 16px 52px',
      width: '100%',
      background:
        'linear-gradient(0deg, rgba(26, 17, 24, 0.08), rgba(26, 17, 24, 0.08))',
      borderRadius: 27,
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '50%',
        left: 16,
        display: 'block',
        width: 22,
        height: 22,
        transform: 'translateY(-50%)',
        backgroundImage: `url("data:image/svg+xml,%3Csvg width='22' height='22' viewBox='0 0 22 22' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11 21C16.5228 21 21 16.5228 21 11C21 5.47715 16.5228 1 11 1C5.47715 1 1 5.47715 1 11C1 16.5228 5.47715 21 11 21Z' stroke='%231A1118' stroke-opacity='0.3' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round'/%3E%3Cpath d='M11 10.1001V16.2001' stroke='%231A1118' stroke-opacity='0.3' stroke-width='1.5' stroke-miterlimit='10' stroke-linecap='round'/%3E%3Cpath d='M11 7.69995C11.5523 7.69995 12 7.25224 12 6.69995C12 6.14767 11.5523 5.69995 11 5.69995C10.4477 5.69995 10 6.14767 10 6.69995C10 7.25224 10.4477 7.69995 11 7.69995Z' fill='%231A1118' fill-opacity='0.3'/%3E%3C/svg%3E")`,
      },
    }),
  })
);
